'use strict';
import React from 'react';
import classnames from 'classnames';
import FormField from 'forms/formField';


export default class Checkbox extends React.Component {

    static propTypes = {
        field: React.PropTypes.object.isRequired
    };

    shouldComponentUpdate = FormField.shouldFormFieldUpdate;

    onChange(e) {
        this.props.field.onChange(e);
    }


    render() {
        var {field, onChange, showErrorMessage, ...inputProps} = this.props;
        var error = field.touched && field.error;
        let value;
        if (field.value !== undefined) {
            value = field.value;
        } else {
            value = field.initialValue;
        }
        let cssClass = classnames(
            'item__input',
            'item__input--checkbox', {
                'item__input--checkbox-checked': value === true
            }, {
                'item__input--error': error
            }
        );
        return (
            <FormField field={field} help={field.help} inputProps={inputProps}>
                <label className={cssClass}>
                    <input type="checkbox" value={true} checked={value} onChange={::this.onChange} />
                    {field.label}
                    { error && showErrorMessage && <div className="input__error">{error}</div>}
                </label>

            </FormField>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/forms/checkbox.jsx